let dirPath = 'games/page010_game0/';
let dirAudio = 'games/page010_game0/audio/';

let configGame = {
  autoCheckAllCorrect: true,
  removeInCorrects: true,
  correctBlock: false,
  rulesGame: {
    otherProperty: {
      sounds: [{ src: dirPath + 'audio/click.mp3', id: 'mouseup' }],
    },
    // itemsConfig: { shuffle: false, block: true },
    items: [
      {
        idGroup: 'source',
        idItem: 's01',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't01',
            correct: [{ idGroup: 'source', idItem: 's01' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's02',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't02',
            correct: [{ idGroup: 'source', idItem: 's02' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's03',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't03',
            correct: [{ idGroup: 'source', idItem: 's03' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's04',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't04',
            correct: [{ idGroup: 'source', idItem: 's04' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's05',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't05',
            correct: [{ idGroup: 'source', idItem: 's05' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's06',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't06',
            correct: [{ idGroup: 'source', idItem: 's06' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's07',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't07',
            correct: [{ idGroup: 'source', idItem: 's07' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's08',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't08',
            correct: [{ idGroup: 'source', idItem: 's08' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's09',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't09',
            correct: [{ idGroup: 'source', idItem: 's09' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's10',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't10',
            correct: [{ idGroup: 'source', idItem: 's10' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's11',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't11',
            correct: [{ idGroup: 'source', idItem: 's11' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's12',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't12',
            correct: [{ idGroup: 'source', idItem: 's12' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's13',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't13',
            correct: [{ idGroup: 'source', idItem: 's13' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's14',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't14',
            correct: [{ idGroup: 'source', idItem: 's14' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: { pos: { width: 792 }, margin: { right: 4 } },
      background: {
        text: {
          font: 'Garamond',
          size: '32px',
          textAlign: 'center',
          textBaseline: 'middle',
        },
      },
    },
    groups: [
      {
        idGroup: 'target',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 205 + 2, y: 181 + 2 },
            { x: 205 + 2, y: 338 + 2 },
            { x: 398 + 2, y: 181 + 2 },
            { x: 398 + 2, y: 338 + 2 },
            { x: 591 + 2, y: 181 + 2 },
            { x: 591 + 2, y: 338 + 2 },
            { x: 591 + 2, y: 494 + 2 },
            { x: 591 + 2, y: 651 + 2 },
            { x: 591 + 2, y: 808 + 2 },
            { x: 784 + 2, y: 181 + 2 },
            { x: 784 + 2, y: 338 + 2 },
            { x: 784 + 2, y: 494 + 2 },
            { x: 784 + 2, y: 651 + 2 },
            { x: 784 + 2, y: 808 + 2 },
          ],
        },
        otherProperty: {
          hooks: {
            autoResize: true,
            background: { color: 'rgba(255,255,255,0.01)' },
            positions: { pos: { width: 96, height: 96 } },
            items: [{ id: 'h01' }],
          },
        },
        items: [
          {
            id: 't01',
            otherProperty: {
              audio: ['a01'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't02',
            otherProperty: {
              audio: ['a02'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't03',
            otherProperty: {
              audio: ['a03'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't04',
            otherProperty: {
              audio: ['a04'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't05',
            otherProperty: {
              audio: ['a05'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't06',
            otherProperty: {
              audio: ['a06'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't07',
            otherProperty: {
              audio: ['a07'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't08',
            otherProperty: {
              audio: ['a08'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't09',
            otherProperty: {
              audio: ['a09'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't10',
            otherProperty: {
              audio: ['a10'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't11',
            otherProperty: {
              audio: ['a11'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't12',
            otherProperty: {
              audio: ['a12'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't13',
            otherProperty: {
              audio: ['a13'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't14',
            otherProperty: {
              audio: ['a14'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 978, y: 202 }, // mole
            { x: 1184, y: 160 }, // tom
            { x: 1408, y: 151 }, // lisa
            { x: 1616, y: 191 }, // blue
            //
            { x: 1408, y: 393 }, // yellow
            { x: 1619, y: 365 }, // bear
            //
            { x: 986, y: 483 }, // green
            { x: 1184, y: 482 }, // red
            { x: 1411, y: 573 }, // hello
            { x: 1619, y: 552 }, // orange
            //
            { x: 982, y: 759 }, // purple
            { x: 1205, y: 733 }, // rabbit
            { x: 1405, y: 758 }, // pink
            { x: 1614, y: 750 }, // bye bye
          ],
        },
        itemsConfig: {
          background: { color: 'rgba(255,255,255,0.01)' },
          positions: {
            pos: { width: 219, height: 219 },
            // rows: 1,
            // margin: { right: 38 },
          },
        },
        // positions: {
        //   type: 'absolute',
        //   pos: { x: 80, y: 920 },
        // },
        items: [
          {
            id: 's01',
            background: {
              image: { src: dirPath + 'img/mole.png', pos: { width: 159, height: 164, x: 2, y: 0 } },
            },
            positions: { pos: { width: 164, height: 164 } },
          },
          {
            id: 's02',
            background: {
              image: { src: dirPath + 'img/tom.png', pos: { width: 146, height: 219, x: 36, y: 0 } },
            },
            positions: { pos: { width: 219, height: 219 } },
          },
          {
            id: 's03',
            background: {
              image: { src: dirPath + 'img/lisa.png', pos: { width: 142, height: 199, x: 28, y: 0 } },
            },
            positions: { pos: { width: 199, height: 199 } },
          },
          {
            id: 's04',
            background: {
              image: { src: dirPath + 'img/blue.png', pos: { width: 140, height: 118, x: 0, y: 11 } },
            },
            positions: { pos: { width: 140, height: 140 } },
          },
          {
            id: 's05',
            background: {
              image: { src: dirPath + 'img/yellow.png', pos: { width: 140, height: 156, x: 8, y: 0 } },
            },
            positions: { pos: { width: 156, height: 156 } },
          },
          {
            id: 's06',
            background: {
              image: { src: dirPath + 'img/bear.png', pos: { width: 134, height: 152, x: 9, y: 0 } },
            },
            positions: { pos: { width: 152, height: 152 } },
          },
          {
            id: 's07',
            background: {
              image: { src: dirPath + 'img/green.png', pos: { width: 142, height: 146, x: 2, y: 0 } },
            },
            positions: { pos: { width: 146, height: 146 } },
          },
          {
            id: 's08',
            background: {
              image: { src: dirPath + 'img/red.png', pos: { width: 159, height: 161, x: 1, y: 0 } },
            },
            positions: { pos: { width: 161, height: 161 } },
          },
          {
            id: 's09',
            background: {
              image: { src: dirPath + 'img/hello.png', pos: { width: 135, height: 161, x: 26, y: 0 } },
            },
            positions: { pos: { width: 161, height: 161 } },
          },
          {
            id: 's10',
            background: {
              image: { src: dirPath + 'img/orange.png', pos: { width: 133, height: 162, x: 14, y: 0 } },
            },
            positions: { pos: { width: 162, height: 162 } },
          },
          {
            id: 's11',
            background: {
              image: { src: dirPath + 'img/purple.png', pos: { width: 151, height: 153, x: 1, y: 0 } },
            },
            positions: { pos: { width: 153, height: 153 } },
          },
          {
            id: 's12',
            background: {
              image: { src: dirPath + 'img/rabbit.png', pos: { width: 138, height: 206, x: 34, y: 0 } },
            },
            positions: { pos: { width: 206, height: 206 } },
          },
          {
            id: 's13',
            background: {
              image: { src: dirPath + 'img/pink.png', pos: { width: 147, height: 156, x: 4, y: 0 } },
            },
            positions: { pos: { width: 156, height: 156 } },
          },
          {
            id: 's14',
            background: {
              image: { src: dirPath + 'img/bye_bye.png', pos: { width: 144, height: 172, x: 28, y: 0 } },
            },
            positions: { pos: { width: 172, height: 172 } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  // blockCheck: true,
  mainImage: {
    imagePath: dirPath + 'img/bcg.webp',
  },
  fullscreen: true,
  mixinEngine: 'dnd',
  mbAudioItemData: [
    {
      id: 'a09',
      src: dirAudio + '1_hello.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a14',
      src: dirAudio + '2_bye_bye.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + '3_Tom.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + '4_Lisa.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a12',
      src: dirAudio + '5_rabbit.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a06',
      src: dirAudio + '6_bear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a01',
      src: dirAudio + '7_mole.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: dirAudio + '8_blue.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a08',
      src: dirAudio + '9_red.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a05',
      src: dirAudio + '10_yellow.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a07',
      src: dirAudio + '11_green.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a11',
      src: dirAudio + '12_purple.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a13',
      src: dirAudio + '13_pink.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a10',
      src: dirAudio + '14_orange.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page010_game0/img/audioOn.png', iconOff: 'games/page010_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
  ],
  configGame: configGame,
};

export default dataConfig;
